import { observer } from 'mobx-react'
import React from 'react'
import { Loader } from 'ui-framework'
import StatsVM from '../StatsVM'
import ReserveDesktop from './ReserveDesktop'
import ReserveMobileItem from './ReserveMobileItem'
import Tvl from './Tvl'

/* This component shows the stats for all reserves.
It has a grid row used for each coin */

const Reserve = ({ vm }: { vm: StatsVM }) => {
  const { stats } = vm.statsStore
  return (
    <>
      <Tvl vm={vm} />

      <div className="reserve__loader-wrapper">
        {(stats.pending || vm.chartStatus.pending) && (
          <Loader className="reserve__loader" quantityDots={3} sizeDots="small" />
        )}
      </div>

      {vm.rootStore.uiStore.media.isMobileMedia ? (
        vm.selectedChainStats.map((item) => (
          <ReserveMobileItem key={item.tokenName} statsItem={item} />
        ))
      ) : (
        <ReserveDesktop statsItems={vm.selectedChainStats} />
      )}
    </>
  )
}

export default observer(Reserve)
